module.exports = __webpack_public_path__ + "static/img/二维动画-逐帧动画.dbe1dbf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/goods/CPK10006/二维动画-逐帧动画.png
// module id = E1dz
// module chunks = 1